import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { User } from "@/types/user";

export interface ResetPasswordData {
  email: User["email"];
  token: string;
  new_password: string;
  confirm_password: string;
}

export interface ResetPasswordResponse {
  success: boolean;
  message: string;
}

export const useResetPassword = () => {
  const [data, setData] = useState<ResetPasswordResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const resetPassword = async (formData: ResetPasswordData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post<ResetPasswordResponse>(
        "users/users/password_reset_confirm/",
        formData,
      );
      setData(response.data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, resetPassword };
};
